/**
 * Helpers de exibição (pt-BR) usados no layout do painel.
 */

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

/** R$ 1.248,50 */
export const formatCurrency = (value) =>
  currencyFormatter.format(Number(value) || 0);

/**
 * Nome de saudação a partir do usuário logado. O /api/auth/me só devolve o
 * e-mail, então usa a parte antes do "@" (ex.: "maria.silva@x" → "Maria").
 */
export const getDisplayName = (user) => {
  const source = String(user?.username || user?.email || "").split("@")[0];
  const first = source.split(/[._\-\s]+/).find(Boolean) || "";
  return first ? first.charAt(0).toUpperCase() + first.slice(1) : "";
};

/** Iniciais para o avatar (ex.: "maria.silva@x" → "MS") */
export const getInitials = (user) => {
  const source = String(user?.username || user?.email || "").split("@")[0];
  const parts = source.split(/[._\-\s]+/).filter(Boolean);
  const initials = parts.length > 1 ? parts[0][0] + parts[1][0] : source.slice(0, 2);
  return initials.toUpperCase() || "?";
};

/** "Quarta-feira" */
export const formatWeekday = (date = new Date()) => {
  const weekday = date.toLocaleDateString("pt-BR", { weekday: "long" });
  return weekday.charAt(0).toUpperCase() + weekday.slice(1);
};

/** "agora", "há 5 min", "há 2 h", "há 3 dias" */
export const formatElapsed = (date, now = new Date()) => {
  if (!date) return "";
  const minutes = Math.max(0, Math.floor((now - date) / 60000));
  if (minutes < 1) return "agora";
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  const days = Math.floor(hours / 24);
  return `há ${days} dia${days > 1 ? "s" : ""}`;
};
